"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaOcorrencia = exports.yupOcorrencia = void 0;
const yup = __importStar(require("yup"));
const utils_1 = require("../utils");
exports.yupOcorrencia = yup.object({
    data: (0, utils_1.sge2Date)()
        .required('A data da Ocorrência é obrigatória')
        .default(() => new Date().toString())
        .label('Data'),
    hora: yup.string().max(8, 'No máximo 8 caracteres.').default('').label('Hora').nullable(),
    restrita: yup.bool().required().label('Ocultar a Ocorrência no Boletim e Aluno Online').default(false),
    bimestre: yup.number().nullable().label('Etapa/Bimestre/Trimestre').default(1),
    historico: yup
        .string()
        .required('Campo histórico é obrigatório')
        .label('Histórico')
        .default('')
        .max(8000, 'Máximo de 8000 caracteres.'),
    imprimir: yup.string().default('').label('que isso?'),
    gerarNotificacao: yup.bool().required().label('Notificar').default(false),
    idAluno: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .required()
        .label('Aluno'),
    idMateria: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .notRequired()
        .nullable()
        .default(null)
        .label('Matéria'),
    idProfessor: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .notRequired()
        .nullable()
        .default(null)
        .label('Professor'),
    idUsuario: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .notRequired()
        .nullable()
        .default(null)
        .label('Usuário'),
    idTipoOcorrencia: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .required()
        .label('Tipo'),
});
exports.schemaOcorrencia = exports.yupOcorrencia.shape({});
